module.exports = __webpack_public_path__ + "static/img/Ricky.Dyson.ccf4b0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ricky.Dyson.jpg
// module id = GMPK
// module chunks = 0